import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuthStore } from '../../stores/useAuthStore'; // 🟢 1. Importamos el store de Zustand
import Spinner from '../common/Spinner';

const ProtectedRouteAdmin = () => {
  // � FIX CRÍTICO #185: Selectores individuales (NO objeto)
  const isLoggedIn = useAuthStore((state) => state.isLoggedIn);
  const currentUser = useAuthStore((state) => state.currentUser);
  const isLoading = useAuthStore((state) => state.isLoading);

  // Mientras se verifica el estado de autenticación, no renderizamos nada.
  if (isLoading) {
    return <div className="flex justify-center items-center h-screen"><Spinner /></div>;
  }

  // 1. Si no hay sesión, envía al login.
  if (!isLoggedIn) {
    return <Navigate to="/auth" replace />;
  }

  // 2. Si hay sesión pero el rol no está en la lista de administradores, envía a la página de inicio.
  const adminRoles = ['admin', 'technician', 'admin_root', 'moderator', 'editor'];
  
  // Verificación robusta de roles (array o string)
  const hasAccess = currentUser?.roles?.some(role => adminRoles.includes(role)) || adminRoles.includes(currentUser?.role);

  if (!hasAccess) {
    return <Navigate to="/" replace />;
  }

  // 3. Si hay sesión y el rol es válido, permite el acceso.
  return <Outlet />;
};

export default ProtectedRouteAdmin;
